// @flow

export const FEEDBACK_PREFIX: 'feedback-' = 'feedback-';
export const FEEDBACK_LOADING: 'feedback-loading' = 'feedback-loading';

export default null;
